<script>
  import {
    Modal,
    ModalBody,
    Table,
    ModalFooter,
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
  } from "sveltestrap";

  export let show;
  export let onCloseClick;
</script>

<style>
.icono{
  font-size: 30px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
}
.txt{
  text-align: center;
}

</style>



<div class="add-event-modal">
  <Modal
    class="exampleModal"
    isOpen={show}
    fade={true}
    centered={true}
    toggle={onCloseClick}
    header="Detalle del viaje"
  >
    <div class="modal-content">
      
      <ModalBody>
        <p class="mb-2">
          Orden ID :  <span class="text-primary">001-12</span>
        </p>
        <p class="mb-4">
          Fecha y hora :<span class="text-primary">07 Oct, 2023. 12:23pm </span>
        </p>
       
        <div class="table-responsive">
          <Table class="table align-middle table-nowrap">
            <thead>
              <tr>
                <th scope="col">Patente</th>
                <th scope="col">Puntos de destino</th>
                

              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      FS6331
                    </h5>
                </th>
                <td>
                  <div>
                    <h5 class="text-truncate font-size-14">
                      Inicio: Santiago 2394
                      <p class="text-muted mb-0">Punto 1: Providencia</p>
                      <p class="text-muted mb-0">Punto 2: Macul</p>
                      <p class="text-muted mb-0">Punto 3: Quinta normal</p>
                      <h5 class="text-truncate font-size-14"> Termino: Santiago 3423  </h5>
                    </h5>
                  </div>
                </td>
              </tr>
             
            </tbody>
          </Table>
          <Table class="table align-middle table-nowrap">
            <thead>
              <h5>Estado de los puntos:</h5>
              <tr>
                <th scope="col">Destinos</th>
                <th scope="col">Estado del viaje</th>
                

              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      <p class="text-muted mb-0">Inicio:</p>
                      <p class="text-muted mb-0">Punto 1: Providencia</p>
                      <p class="text-muted mb-0">Punto 2: Macul</p>
                      <p class="text-muted mb-0">Punto 3: Quinta normal</p>
                      <p class="text-muted mb-0">Termino: </p>
                    </h5>
                </th>
                <td>
                  <div>
                    <h5 class="text-truncate font-size-14">
                      Recorrido iniciado
                      <p class="text-muted mb-0">Completado</p>
                      <p class="text-muted mb-0">Cancelada</p>
                      <p class="text-muted mb-0">Completado</p>
                      <h5 class="text-truncate font-size-14"> En espera</h5>
                    </h5>
                  </div>
                </td>
              </tr>
             
            </tbody>
          </Table>
        </div>
        <div class="table-responsive">
          <Table class="table align-middle table-nowrap">
            <thead>
              <h5>Notificaciones:</h5>
              <tr>
                <th scope="col">Hora de la alerta</th>
                <th scope="col">Tipo de alerta</th>
                <th scope="col">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      FS6331
                    </h5>
                  </div>
                </th>
                <td>
                  <i class=" icono  mdi mdi-car-brake-alert"/>
                  <p class=" txt text-muted mb-0">TRABA </p>
                </td>
                <td>
                  <div>
                   Recepcionado
                  </div>
                </td>
              
              </tr>
          
          
            </tbody>
          </Table>
          <Table class="table align-middle table-nowrap">
            <thead>
              <h5>Mensaje de resplado:</h5>
              <tr>
                <p class="text-muted mb-0">Si deseas enviar un mensaje de forma manual escribele Aquí</p>
              </tr>
              <Label for="message">Mensaje</Label>
                            <Input
                              type="textarea"
                              id="message"
                              placeholder="Escribe el mensaje"
                            />
            </thead>
          
           
          </Table>
          <Button type="button" color="primary" on:click={onCloseClick}>Enviar</Button>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="primary" on:click={onCloseClick}>Cerrar</Button>
      </ModalFooter>
    </div>
  </Modal>
</div>